/* * @Author: zxx * @Date: 2020/3/26 * @instraction: 添加用户 */
<template>
  <KllkDrawer v-model="isShowDrawer" class="create-drawer">
    <!-- 按钮 -->
    <div slot="header" class="header-warp">
      <el-button type="primary" @click="onSave" class="btns">保存</el-button>
      <el-button @click="onCancel" class="btns">取消</el-button>
    </div>
    <!-- 内容 -->
    <el-form
      ref="userForm"
      label-position="left"
      :model="userForm"
      :rules="usersRules"
      label-width="90px"
      class="dic-add"
    >
      <el-row type="flex" justify="space-around">
        <el-col :span="24">
          <el-form-item label="名称" prop="userName">
            <el-input v-model="userForm.userName" maxlength="32"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="24">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="userForm.email"  type="email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around" v-if="userForm.userId">
        <el-col :span="24">
          <el-form-item label="修改密码" prop="password">
            <el-input v-model="userForm.password" show-password></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </KllkDrawer>
</template>
<script>
// 引入组件
import KllkDrawer from "../../components/kllk-drawer";
// api
import { PostAddUser, PutEditUser } from "../../api/user";
// js
import md5 from "md5"
export default {
  components: { KllkDrawer },
  props: {
    value: Boolean,
    editForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isShowDrawer: this.value,
      userForm: {
        userName: "",
        email: "",
        password: null
      },
      usersRules: {
        userName: [{ required: true, message: " ", trigger: "blur" }],
        email: [{ required: true, message: " ", trigger: "blur" }],
      }
    };
  },
  computed: {
    // false 普通用户， true 管理员；只有管理员才可以操作用户
    admin() {
      return true ? sessionStorage.getItem("admin") == "true" : false
    },
  },
  methods: {
    // 保存
    onSave() {
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          // 修改
          if (this.userForm.userId) {
            this.handleEdit();
          } else {
            //添加
            this.handleSave();
          }
        } else {
          this.$notify({
            title: "警告",
            message: "请填写正确信息",
            type: "warning"
          });
        }
      });
    },
    handleSave() {
      PostAddUser(this.userForm).then(res => {
        if (res.status) {
          this.$notify({
            title: "成功",
            message: "添加成功",
            type: "success"
          });
          this.$emit("on-update");
          this.onCancel();
        }
      });
    },
    handleEdit() {
      if (this.userForm.password) {
         this.userForm.password = md5(this.userForm.password)
      }
      PutEditUser(this.userForm).then(res => {
        if (res.status) {
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success"
          });
          this.$emit("on-update");
          this.onCancel();
        }
      });
    },
    onCancel() {
      this.isShowDrawer = false;
    }
  },
  computed: {},
  watch: {
    value(n) {
      this.isShowDrawer = n;
    },
    isShowDrawer(n) {
      this.$emit("input", n);
      // 抽屉关闭，清空数据
      if (!n) {
        this.userForm.userName = "";
        this.userForm.email = "";
        this.userForm.userId = null
      }
    },
    editForm(n) {
      if (n.userId) {
        this.userForm = {
          userId: n.userId,
          userName: n.userName,
          email: n.email,
          password: n.password
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.create-drawer {
  .header-warp {
    background: #f5f8fa;
    padding: 16px;

    .btns {
      margin: 0 5px;
    }
  }

  .dic-add {
    padding: 20px;
  }
}
</style>
